import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        heroBannerContainer: {
            w: '100%',
            m: '0 auto',
            position: 'relative',
        },
        heroBannerMain: {
            w: '100%',
            position: 'relative',
        },
        heroBannerVideo: {
            position: 'relative',
            width: '100%',
            _after: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: 'none',
            },
        },
        heroBannerImage: {
            objectFit: 'cover',
            objectPosition: 'center',
            width: '100vw',
            height: '100%',
            position: {base: 'relative', lg: 'absolute'},
            inset: '0',
            zIndex: '0',
        },
        heroBannerUnified: {
            display: 'flex',
            position: {base: 'relative', lg: 'absolute'},
            height: {base: 'unset', lg: '100%'},
            width: '100%',
        },
        heroBannerDesktop: {
            display: {base: 'none', md: 'none', lg: 'flex'},
            position: {base: 'relative', lg: 'absolute'},
            height: {base: 'unset', lg: '100%'},
            width: '100%',
        },
        heroBannerMobile: {
            display: {base: 'flex', md: 'flex', lg: 'none'},
        },
        v2HeroBannerContainer: {},
        v2HeroBannerMain: {
            flexDirection: {base: 'column', lg: 'row'},
            minH: 0,
        },
        v2HeroBannerVideo: {},
        v2HeroBannerDesktop: {},
        v2HeroBannerMobile: {
            minH: 0,
            overflowY: 'visible',
        },
        v2SwipeContainer: {
            touchAction: 'pan-y',
        },
        v2Layout: {
            maxH: {base: 'none', md: remCalc(637), lg: remCalc(850)},
            overflow: 'hidden',
        },
        v2BentoLayout: {
            direction: {base: 'column', lg: 'row'},
            align: 'stretch',
            maxH: {base: 'none', md: remCalc(752), lg: remCalc(850)},
            gap: {base: remCalc(12), lg: 'xsmall.base'},
            w: '100%',
            alignItems: {base: 'stretch', md: 'center', lg: 'stretch'},
            p: {base: 'xsmall.base', md: remCalc(24), lg: 'medium.base'},
        },
        v2BentoColumn: {
            w: {base: '100%', md: remCalc(704), lg: remCalc(344)},
            flexShrink: 0,
        },
        v2BentoBox: {
            direction: {base: 'column', md: 'row', lg: 'column'},
            gap: {base: remCalc(12), lg: 'xsmall.base'},
            w: '100%',
            h: {base: 'auto', lg: '100%'},
        },
        v2BentoCard: {
            borderRadius: 'large-1',
            backdropFilter: 'blur(12px)',
            p: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: remCalc(20),
            w: '100%',
            minW: 0,
            h: {base: remCalc(120), lg: 'auto'},
            overflow: 'hidden',
        },
        v2BentoCardContent: {
            direction: 'column',
            justify: 'space-between',
            flex: 1,
            minH: '100%',
        },
        v2BentoIcon: {
            boxSize: remCalc(20),
        },
        v2BentoTextRow: {
            align: 'flex-end',
            justify: 'space-between',
            gap: remCalc(12),
            mt: 'auto',
        },
        v2BentoTitleGroup: {
            direction: 'column',
            gap: 'xxxsmall.base',
            alignItems: 'flex-start',
            flex: 1,
        },
        v2BentoTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
        },
        v2BentoSubtitle: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        v2BentoCta: {
            variant: 'outline',
            borderRadius: 'full',
            minW: remCalc(32),
            w: remCalc(32),
            h: remCalc(32),
            p: 0,
            flexShrink: 0,
        },
    },
}
